









































import {Vue,Component} from 'vue-property-decorator'
import TablaGeneralFinalComponent from '@/components/General/TablaGeneralFinal.vue';
import Formulario from '@/components/Maestro/Largo/Formulario.vue'
import {Largo, EditarEstadoLargo, ObtenerLargo} from '@/entidades/Maestro/Ktb/Largo';
import { Action } from 'vuex-class';
import Loading from '@/entidades/Sistema/Loading';
import Alerta from '@/entidades/Sistema/Alerta';
@Component({
    components:{
        'Tabla' : TablaGeneralFinalComponent,
        'Formulario' :Formulario
    }
})
export default class LargoView extends Vue
{
    @Action('changeLoading',{namespace:'sistemaModule'}) changeLoading!:Function;
    @Action('changeAlerta',{namespace:'sistemaModule'}) changeAlerta!:Function;
    header:{text:string,sortable:boolean,value:string}[] =
    [
            {text:"Descripcion",sortable:true,value:'descripcion'},
            {text:"Pie",sortable:true,value:'pie'},
            {text:"Desc. Pulgada",sortable:true,value:'descripcionPulgada'},
            {text:"Pulgada",sortable:true,value:'pulgada'},
            {text:"Desc. Pulgada Comercial",sortable:true,value:'descripcionPulgadaComercial'},
            {text:"Pulgada Comercial",sortable:true,value:'pulgadaComercial'},
            {text:"Action",sortable:false,value:'actions'},
            {text:"Estado",sortable:true,value:'estado'}            
    ];
    modal:boolean=false;
    currentComponent:string="";
    listado:Array<Largo> = [];
    modelo:Largo |undefined= undefined;
    actions:number =1;
    async editarEstado(Largo:Largo)
    {
        try
        {
            this.changeLoading(new Loading(true,"Editando informacion"));
            let rsp = await EditarEstadoLargo(Largo);
            if(rsp.isSuccess == true)
            {
                this.limpiar();
            }
            else 
            {
                this.changeAlerta(new Alerta(rsp.isMessage,true,"danger",3000));
            }
        }
        catch(error)
        {
            console.log(error);
        }
        finally
        {
            this.changeLoading(new Loading(false,""));
        }
    }

    async abrilModal()
    {
        this.actions = 1;
        this.currentComponent = 'Formulario';
        this.modal= true;
    }
    editarModal(Largo:Largo)
    {
        this.currentComponent = "Formulario";
        this.actions = 2;
        this.modelo = Largo;
        this.modal = true;
    }

    async Obtener()
    {
        try
        {
            let rsp = await ObtenerLargo();
            if(rsp.isSuccess == true)
            {
                this.listado = rsp.isResult;
            }
            else
            {
                this.changeAlerta(new Alerta(rsp.isMessage,true,"danger",3000));
            }
        }
        catch(error)
        {
            console.log(error);
        }
        finally
        {
            this.changeLoading(new Loading(false,""));
        }
    }

    limpiar()
    {
        this.modelo = undefined;
        this.Obtener();
        this.modal = false;
        this.currentComponent = '';
        
    }

    get getPropiedades()
    {
       if(this.currentComponent == "Formulario")
        {
            return {'action' :this.actions, 'modelo' :this.modelo};
        }
    }


    mounted() {
     this.Obtener();   
    }

}
